import { BrowserRouter, Route, Routes } from "react-router-dom";

import { Box, CircularProgress, ThemeProvider } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import {
  AddCarrier,
  Admin,
  AuthLogin,
  BerlinQuestionaire,
  ContactUs,
  CreditCardPayment,
  Dashboard,
  DeleteRecord,
  DmeOrder,
  EpworthSleepinessScale,
  ForgotPassword,
  GroupView,
  InsuranceView,
  InterpPhysView,
  LocationView,
  MakePayment,
  MFASetup,
  NewOrder,
  NewSurvey,
  NotFoundPage,
  OrderInfoDialog,
  OrderView,
  PatientPortalHomePage,
  PatientPortalPastVisits,
  PatientPortalProfilePage,
  Patients,
  PatientView,
  PhysicianProfile,
  Profile,
  QualityImprovementSurvey,
  ReferralView,
  Reports,
  RoleView,
  SatisfactionSurvey,
  Scheduling,
  SignIn,
  SignInInitial,
  SignInLanding,
  SignInPatient,
  StopBangQuestionaire,
  SurveyView,
  TableData,
  UserView,
} from "@route-components";
import React, { Suspense, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Navigate } from "../node_modules/react-router-dom/dist/index";
import "./App.scss";
import AppNavigate from "./components/AppNavigate";
import Layout from "./components/Layout";
import { AUTH_ROUTES, PROVIDER_PORTAL_ROUTES } from "./constants/allRoutePaths";
import { isTokenExpired } from "./constants/tokenValidator";
import { ErrorProvider } from "./Context/ErrorContext";
import AppProvider from "./hooks/AppProvider";
import { useAuth } from "./hooks/auth";
import { setSnackbarMessage } from "./store/slices/snackBarSlice";
import { theme } from "./Theme/theme";
import useSessionTimeout from "./useSessionTimeout";
import { getSignInLandingUrl } from "./utils/navigationUtils";
import { clearPatientData } from "./utils/patientUtils";
import roleAndPrivilegesFnc from "./utils/roleAndPriviledges";

const signInLandingUrl = getSignInLandingUrl();

export const ProtectRoutes = () => {
  const { cookies } = useAuth();

  let redirectPath;

  if (cookies?.token) {
    const { tabPath } = roleAndPrivilegesFnc(cookies?.token);
    redirectPath = tabPath;
  } else {
    const signInLandingUrl = getSignInLandingUrl();

    return <AppNavigate to={signInLandingUrl} />;
  }

  return <Layout tabPath={redirectPath} />;
};

export const PatientPoratlProtectRoutes = () => {
  const { cookies } = useAuth();

  if (cookies?.token && cookies?.isPatient) {
    return <Layout isPatient={cookies?.isPatient} />;
  }

  const signInLandingUrl = getSignInLandingUrl();

  return <AppNavigate to={signInLandingUrl} />;
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const RouteLoader = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
    }}
  >
    <CircularProgress />
  </Box>
);

const withSuspense = (Component) => (
  <Suspense fallback={<RouteLoader />}>
    <Component />
  </Suspense>
);

// const AuthLogin = lazy(() => import("./components/AuthLogin"));

// const Dashboard = lazy(() => import("./components/Dashboard"));

// const Admin = lazy(() => import("./components/Admin"));

// const Profile = lazy(() => import("./components/Profile"));

// const SignIn = lazy(() => import("./components/SignIn"));

// const TableData = lazy(() =>
//   import("./components/TableData").then((m) => ({
//     default: m.TableData,
//   })),
// );

// const OrderInfoDialog = lazy(() => import("./components/misc/OrderInfoDialog"));

// const AddCarrier = lazy(() => import("./pages/AddCarrier"));

// const DeleteRecord = lazy(() => import("./pages/DeleteRecord"));

// const BerlinQuestionaire = lazy(() =>
//   import("./pages/forms/BerlinQuestionaire"),
// );

// const EpworthSleepinessScale = lazy(() =>
//   import("./pages/forms/EpworthSleepinessScale"),
// );

// const QualityImprovementSurvey = lazy(() =>
//   import("./pages/forms/QualityImprovementSurvey"),
// );

// const SatisfactionSurvey = lazy(() =>
//   import("./pages/forms/SatisfactionSurvey"),
// );

// const StopBangQuestionaire = lazy(() =>
//   import("./pages/forms/StopBangQuestionaire"),
// );

// const GroupView = lazy(() => import("./pages/GroupView"));

// const InsuranceView = lazy(() => import("./pages/InsuranceView"));

// const InterpPhysView = lazy(() => import("./pages/InterpPhysView"));

// const LocationView = lazy(() => import("./pages/LocationView"));

// const NotFoundPage = lazy(() => import("./pages/pageNotFound/NotFoundPage"));

// const ContactUs = lazy(() =>
//   import("./pages/patientPortal/contactUs/ContactUs"),
// );

// const PatientPortalHomePage = lazy(() =>
//   import("./pages/patientPortal/patientPortalHomePage/PatientPortalHomePage"),
// );

// const PatientPortalPastVisits = lazy(() =>
//   import(
//     "./pages/patientPortal/patientPortalPastVisits/PatientPortalPastVisits"
//   ),
// );

// const PatientPortalProfilePage = lazy(() =>
//   import("./pages/patientPortal/patientPortalProfile/PatientPortalProfilePage"),
// );

// const Scheduling = lazy(() =>
//   import("./pages/patientPortal/Scheduling/Scheduling"),
// );

// const ForgotPassword = lazy(() =>
//   import("./pages/patientPortal/signInLanding/ForgotPassword"),
// );

// const MFASetup = lazy(() =>
//   import("./pages/patientPortal/signInLanding/MFASetup"),
// );

// const SignInInitial = lazy(() =>
//   import("./pages/patientPortal/signInLanding/SignInInitial"),
// );

// const SignInLanding = lazy(() =>
//   import("./pages/patientPortal/signInLanding/SignInLanding"),
// );

// const SignInPatient = lazy(() =>
//   import("./pages/patientPortal/signInLanding/SignInPatient"),
// );

// const CreditCardPayment = lazy(() =>
//   import("./pages/patients/components/CreditCardPayment/CreditCardPayment"),
// );

// const MakePayment = lazy(() =>
//   import("./pages/patients/components/CreditCardPayment/MakePayment"),
// );

// const NewOrder = lazy(() =>
//   import("./pages/patients/components/newOrder/NewOrder"),
// );

// const NewSurvey = lazy(() => import("./pages/patients/components/NewSurvey"));

// const OrderView = lazy(() => import("./pages/patients/components/OrderView"));

// const PatientView = lazy(() =>
//   import("./pages/patients/components/PatientView"),
// );

// const SurveyView = lazy(() => import("./pages/patients/components/SurveyView"));

// const DmeOrder = lazy(() => import("./pages/patients/dmeOrder/DmeOrder"));

// const Patients = lazy(() => import("./pages/patients/Patients"));

// const PhysicianProfile = lazy(() => import("./pages/PhysicianProfile"));

// const ReferralView = lazy(() => import("./pages/ReferralView"));

// const Reports = lazy(() => import("./pages/reports/Reports"));

// const RoleView = lazy(() => import("./pages/RoleView"));

// const UserView = lazy(() => import("./pages/UserView"));

function App() {
  const [cookies] = useCookies();
  const { messageObject } = useSelector((state) => state.snackBarSelector);
  const dispatch = useDispatch();
  useSessionTimeout();

  const getCurrentTenantId = () => {
    return localStorage.getItem("currentTenantId");
  };

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "logout") {
        clearPatientData(dispatch);
        window.location.href = getSignInLandingUrl();
      }
      if (event.key === "tenantChange") {
        const data = JSON.parse(event.newValue);

        const currentTenantId = getCurrentTenantId();
        if (data?.tenantId !== currentTenantId) {
          // Tenant has changed in another tab
          clearPatientData(dispatch);
          window.location.reload();
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const InvalidReferralView = () => <OrderInfoDialog asDialog={false} />;

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <AppProvider>
          <ErrorProvider>
            {/* <TimeoutLogic /> */}
            <Snackbar
              open={!!messageObject?.message}
              autoHideDuration={messageObject?.type === "error" ? 8000 : 4000}
              onClose={() => {
                dispatch(setSnackbarMessage(null));
              }}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert
                onClose={() => {
                  dispatch(setSnackbarMessage(null));
                }}
                severity={messageObject?.type}
                sx={{ width: "100%" }}
              >
                {messageObject?.message}
              </Alert>
            </Snackbar>
            <Suspense
              fallback={
                <Box
                  sx={{
                    display: "flex",
                    minHeight: "100vh",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress />
                </Box>
              }
            >
              <Routes>
                <Route path="/authlogin" element={withSuspense(AuthLogin)} />

                <Route
                  path={`/${AUTH_ROUTES.SIGNIN_INITIAL_PROVIDER}`}
                  index
                  element={
                    cookies?.token &&
                    !isTokenExpired(cookies?.token) &&
                    !cookies?.isPatient ? (
                      <Navigate to="/" />
                    ) : (
                      withSuspense(SignInInitial)
                    )
                  }
                />

                <Route
                  path={`/${AUTH_ROUTES.SIGNIN_INITIAL_PATIENT}`}
                  index
                  element={
                    cookies?.token &&
                    !isTokenExpired(cookies?.token) &&
                    cookies?.isPatient ? (
                      <Navigate to="/" />
                    ) : (
                      withSuspense(SignInInitial)
                    )
                  }
                />

                <Route path="/signin" index element={withSuspense(SignIn)} />

                <Route
                  path="/setup-mfa"
                  index
                  element={withSuspense(MFASetup)}
                />

                <Route
                  path={`/${AUTH_ROUTES.SIGNIN_LANDING}`}
                  index
                  element={
                    cookies?.token ? (
                      <Navigate to="/" />
                    ) : (
                      withSuspense(SignInLanding)
                    )
                  }
                />

                <Route
                  path={`/${AUTH_ROUTES.SIGNIN_AS_PATIENT}`}
                  index
                  element={withSuspense(SignInPatient)}
                />

                <Route
                  path="/forgot-password"
                  index
                  element={withSuspense(ForgotPassword)}
                />

                <Route path="*" element={withSuspense(NotFoundPage)} />

                {
                  // protected route for testPortal
                  cookies?.token && !cookies?.isPatient && (
                    <Route
                      path="/"
                      element={
                        <ErrorProvider>
                          <ProtectRoutes />
                        </ErrorProvider>
                      }
                    >
                      <Route path="/" element={<Navigate to="/dashboard" />} />
                      <Route
                        path="dashboard"
                        element={withSuspense(Dashboard)}
                      />
                      <Route path="profile" element={withSuspense(Profile)} />
                      <Route path="patients" element={withSuspense(Patients)} />
                      <Route
                        path="scheduler"
                        element={withSuspense(Scheduling)}
                      />
                      <Route path="reports" element={withSuspense(Reports)} />
                      <Route path="admin" element={withSuspense(Admin)} />
                      <Route
                        path="physician-profile"
                        element={withSuspense(PhysicianProfile)}
                      />
                      <Route
                        path="new-survey"
                        element={withSuspense(NewSurvey)}
                      />
                      <Route
                        path="new-order"
                        element={withSuspense(NewOrder)}
                      />
                      <Route
                        path="patient-view"
                        element={withSuspense(PatientView)}
                      />
                      <Route
                        path="user-view"
                        element={withSuspense(UserView)}
                      />
                      <Route
                        path="group-view"
                        element={withSuspense(GroupView)}
                      />
                      <Route
                        path="role-view"
                        element={withSuspense(RoleView)}
                      />
                      <Route
                        path="location-view"
                        element={withSuspense(LocationView)}
                      />
                      <Route
                        path="insurance-view"
                        element={withSuspense(InsuranceView)}
                      />
                      <Route
                        path="delete-record"
                        element={withSuspense(DeleteRecord)}
                      />
                      <Route
                        path="add-carrier"
                        element={withSuspense(AddCarrier)}
                      />
                      <Route
                        path="stop-bang"
                        element={withSuspense(StopBangQuestionaire)}
                      />
                      <Route
                        path="berlin-questionaire"
                        element={withSuspense(BerlinQuestionaire)}
                      />
                      <Route
                        path="satisfaction-survey"
                        element={withSuspense(SatisfactionSurvey)}
                      />
                      <Route
                        path="quality-improvement-survey"
                        element={withSuspense(QualityImprovementSurvey)}
                      />
                      <Route
                        path="epworth-sleepiness-scale"
                        element={withSuspense(EpworthSleepinessScale)}
                      />
                      <Route
                        path="interp-phys-view"
                        element={withSuspense(InterpPhysView)}
                      />
                      <Route
                        path="survey-view"
                        element={withSuspense(SurveyView)}
                      />
                      <Route
                        path="order-view"
                        element={withSuspense(OrderView)}
                      />
                      <Route
                        path={PROVIDER_PORTAL_ROUTES.INVALID_REFERRAL_VIEW}
                        element={withSuspense(InvalidReferralView)}
                      />
                      <Route
                        path={
                          PROVIDER_PORTAL_ROUTES.ADD_PATIENT_BY_SLEEP_ORDER_UPLOAD
                        }
                        element={withSuspense(ReferralView)}
                      />
                      <Route
                        path={
                          PROVIDER_PORTAL_ROUTES.ADD_PATIENT_BY_DME_ORDER_UPLOAD
                        }
                        element={withSuspense(ReferralView)}
                      />
                      <Route
                        path={PROVIDER_PORTAL_ROUTES.SLEEP_REFERRAL_VIEW}
                        element={withSuspense(ReferralView)}
                      />
                      <Route
                        path={PROVIDER_PORTAL_ROUTES.DME_REFERRAL_VIEW}
                        element={withSuspense(ReferralView)}
                      />
                      <Route path="example" element={withSuspense(TableData)} />
                      <Route
                        path="dme-order"
                        element={withSuspense(DmeOrder)}
                      />
                      <Route
                        path="make-payment"
                        element={withSuspense(MakePayment)}
                      />
                      <Route
                        path="credit-card-payment"
                        element={withSuspense(CreditCardPayment)}
                      />{" "}
                    </Route>
                  )
                }
                {
                  // protected route for patientPortal
                  cookies?.token && cookies?.isPatient && (
                    <Route
                      path="/"
                      element={
                        <ErrorProvider>
                          <PatientPoratlProtectRoutes />
                        </ErrorProvider>
                      }
                    >
                      <Route
                        path="/"
                        element={<Navigate to="/patient-portal" />}
                      />
                      <Route
                        path="patient-portal"
                        element={withSuspense(PatientPortalHomePage)}
                      />
                      <Route
                        path="patient-profile"
                        element={withSuspense(PatientPortalProfilePage)}
                      />
                      <Route
                        path="scheduler"
                        element={withSuspense(Scheduling)}
                      />
                      <Route
                        path="patient-past-visits"
                        element={withSuspense(PatientPortalPastVisits)}
                      />
                      <Route
                        path="contact-us"
                        element={withSuspense(ContactUs)}
                      />
                      <Route
                        path="make-payment"
                        element={withSuspense(MakePayment)}
                      />
                      <Route
                        path="credit-card-payment"
                        element={withSuspense(CreditCardPayment)}
                      />
                    </Route>
                  )
                }
              </Routes>
            </Suspense>
            <ToastContainer />
          </ErrorProvider>
        </AppProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
